import { TrainingAPI } from "../../api/TrainingAPI";

const trainingAPI = new TrainingAPI();

export const CALENDAR_SET_DATA = "[CALENDAR]_SET_DATA";
export const CALENDAR_SET_COLORS = "[CALENDAR]_SET_COLORS";
export const CALENDAR_SET_METRICS = "[CALENDAR]_SET_METRICS";

export const setCalendarData = (data) => ({
  type: CALENDAR_SET_DATA,
  payload: data,
});

export const setCalendarColors = (colors) => ({
  type: CALENDAR_SET_COLORS,
  payload: colors,
});

export const setCalendarMetrics = (metrics) => ({
  type: CALENDAR_SET_METRICS,
  payload: metrics,
});

export const getYearDataV2 = (start_date, end_date, setLoading = null) => {
  return async (dispatch) => {
    try {
      const data = await trainingAPI.getYearTrainingsV2(start_date, end_date);
      dispatch(setCalendarData(data.data));
      dispatch(setCalendarColors(data.colors));
      dispatch(setCalendarMetrics(data.metrics));
      if (setLoading) setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };
};
